import cn from 'classnames';
import { useState } from 'react';

import { useDictionary } from 'src/hooks/useDictionary';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import Cta from 'components/BaseHelpers/Cta';
import PeopleGrid from 'components/BaseHelpers/PeopleGrid';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreContactsGridData } from '../../../types/components';

import styles from './CoreContactsGrid.module.scss';

export type CoreContactsGridProps = ComponentProps & CoreContactsGridData;

const CoreContactsGrid = (props: CoreContactsGridProps): JSX.Element => {
  const { heading, description, items, variant, jumpLinkLabel } = props.fields;
  const [numberToShow, setNumberToShow] = useState(
    variant === 'cta-show-all-button' ? (props.fields.displayCount ?? 6) : items.length
  );

  const { showAllLabel } = useDictionary();

  const hasCallToAction = variant === 'cta-link' && props.fields.cta.href;

  if (items.length === 0 && !hasCallToAction) {
    return <></>;
  }

  return (
    <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
      <Text tag="h2" className={cn('heading-h3', styles.heading)} field={heading} />
      <RichText className="body-med" field={description} />
      <PeopleGrid items={items.slice(0, numberToShow)} className={styles.list} />
      {variant === 'cta-link' && props.fields.cta && (
        <Cta tag="a" href={props.fields.cta.href} className={styles.cta} showIcon={true}>
          {props.fields.cta.label || showAllLabel}
        </Cta>
      )}
      {variant === 'cta-show-all-button' && numberToShow < items.length && (
        <Cta
          tag="button"
          onClick={() => setNumberToShow(items.length)}
          className={styles.cta}
          showIcon={false}
        >
          {showAllLabel}
        </Cta>
      )}
    </div>
  );
};

export default CoreContactsGrid;
